import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExpenseService {

  private apiUrl = environment.apiUrl + '/concept_expenses/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

    get(conceptResponseId?:any): Observable<any[]> {
        let httpParams = new HttpParams();
        if (conceptResponseId) httpParams = httpParams.set('conceptResponseId', conceptResponseId.toString());
        return this.http.get<any[]>(this.apiUrl+'get/', { params: httpParams });
    }
    save(expenseReport: any): Observable<any> {
        return this.http.post<any>(this.apiUrl+'save/', expenseReport);
    }
    update(id: String, expenseReport: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl+'update'}/${id}`, expenseReport);
    }

    delete(expenseId: String) {
        return this.http.delete<any>(`${this.apiUrl+'delete'}/${expenseId}`);
    }

    deleteAllByConceptResponseId(conceptResponseId:String){
        return this.http.delete<any>(`${this.apiUrl+'deleteAllByConceptResponseId'}/${conceptResponseId}`);
    }

}